import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import LayoutFinish from '../components/LayoutFinish/LayoutFinish';
import ErrorPayment from '../components/ErrorPayment/ErrorPayment';

import { resetStep } from './../actions/card';

class ErrorPaymentScreen extends Component {

  componentDidMount() {
    if (this.props.mainClubID) {
      this.props.resetStep(1);
    } else {
      window.location = `${window.location.origin}`;
    }
  }

  render() {
    return(
      <LayoutFinish page="error-payment">
        <ErrorPayment />
      </LayoutFinish>
    )
  }
}

function mapStateToProps(state) {
  return {
    mainClubID: state.card.mainClubID,
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  resetStep
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPaymentScreen);